import { useTranslation } from '@presentation/utils';
import { Form, Formik } from 'formik';
import type { FC } from 'react';
import {
  Button,
  Card,
  InputField,
  InputLabel,
  InputWrapper,
  Modal,
  ModalCloseButton,
  Section,
  SectionTitle,
} from '..';
import type {
  MtSocialProvidersLinkEmailFormValues,
  MtSocialProvidersLinkEmailModalProps,
} from './types';

export * from './types';

export const MtSocialProvidersLinkEmailModal: FC<MtSocialProvidersLinkEmailModalProps> = (
  props,
) => {
  const { modal, form, ...rest } = props;
  const { translate } = useTranslation();

  return (
    <Modal {...modal} {...rest}>
      <Card size="small" isModal>
        <ModalCloseButton modal={modal} />
        <SectionTitle>{translate('common.modals.linkAccount.title')}</SectionTitle>
        <Section>
          <Formik<MtSocialProvidersLinkEmailFormValues> {...form} enableReinitialize>
            {({ isSubmitting }) => (
              <Form>
                <InputWrapper>
                  <InputLabel required>{translate('common.inputs.email.label')}</InputLabel>
                  <InputField name="email" type="email" />
                </InputWrapper>

                <InputWrapper>
                  <InputLabel required>{translate('common.inputs.password.label')}</InputLabel>
                  <InputField name="password" type="password" />
                </InputWrapper>

                <InputWrapper>
                  <InputLabel required>
                    {translate('common.inputs.passwordRepeat.label')}
                  </InputLabel>
                  <InputField name="confirmPassword" type="password" />
                </InputWrapper>

                <InputWrapper>
                  <Button color="blue" loading={isSubmitting} type="submit">
                    {translate('common.buttons.linkAccount')}
                  </Button>
                </InputWrapper>
              </Form>
            )}
          </Formik>
        </Section>
      </Card>
    </Modal>
  );
};
